/** sessionStorage key both SignIn (writes it before leaving) and SsoCallback (reads it back) share. */
export const SSO_STATE_KEY = 'sv-cloud-sso-state';

/**
 * sessionStorage key for where SsoCallback should land after a successful
 * exchange, instead of its default `/projects`. Written by any pre-auth
 * screen that needs the browser back on itself: today, only
 * OauthAuthorize.tsx, which stashes its own `/oauth/authorize?...` URL
 * before bouncing to `/sign-in` so a CLI login's consent step survives the
 * Loop SSO round trip. Read once and cleared, same as SSO_STATE_KEY.
 */
export const POST_LOGIN_PATH_KEY = 'sv-cloud-post-login-path';
